import "@/App.css";
import { useEffect } from "react";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { HelmetProvider } from "react-helmet-async";
import HomePage from "./pages/HomePage";
import ServiceDetailPage from "./pages/ServiceDetailPage";
import { Header } from "./components/site/Header";
import { Footer } from "./components/site/Footer";
import { FloatingWhatsApp } from "./components/site/FloatingWhatsApp";

function ScrollToHash() {
  const { pathname, hash } = useLocation();

  useEffect(() => {
    if (!hash) return;

    const timer = window.setTimeout(() => {
      const target = document.getElementById(decodeURIComponent(hash.slice(1)));
      target?.scrollIntoView({ behavior: "smooth", block: "start" });
    }, 50);

    return () => window.clearTimeout(timer);
  }, [pathname, hash]);

  return null;
}

function App() {
  return (
    <HelmetProvider>
      <BrowserRouter>
        <ScrollToHash />
        <div className="App min-h-screen bg-white text-zinc-950 flex flex-col">
          <Header />
          <main className="flex-1">
            <Routes>
              <Route path="/" element={<HomePage />} />
              <Route path="/hizmetler/:slug" element={<ServiceDetailPage />} />
              <Route path="*" element={<HomePage />} />
            </Routes>
          </main>
          <FloatingWhatsApp />
        </div>
      </BrowserRouter>
    </HelmetProvider>
  );
}

export default App;
